import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';
import NetworkAddToWallet from 'ui/shared/NetworkAddToWallet';
import NetworkLogo from 'ui/snippets/networkMenu/NetworkLogo';

import IntTxsIndexingStatus from './IntTxsIndexingStatus';

const Footer = () => {
  return (
    <Box
      as="footer"
      borderTop="1px solid"
      borderTopColor="blue.100"
      bg="white"
      mt={ 10 }
    >
      <Flex
        px={{ base: 4, lg: config.UI.navigation.layout === 'horizontal' ? 6 : 12, '2xl': 6 }}
        py={{ base: 6, lg: 8 }}
        maxW={ `${ CONTENT_MAX_WIDTH }px` }
        mx="auto"
        direction={{ base: 'column', lg: 'row' }}
        align={{ base: 'flex-start', lg: 'center' }}
        justify="space-between"
        gap={ 6 }
      >
        <Box maxW="560px">
          <NetworkLogo isCollapsed={ false }/>
          <Text mt={ 4 } color="text.secondary" textStyle="sm" lineHeight="1.9">
            کاوشگر رسمی زنجیره صبا برای مشاهده و تحلیل بلاک‌ها، تراکنش‌ها، آدرس‌ها، توکن‌ها و قراردادهای هوشمند.
          </Text>
          <Text mt={ 3 } color="blue.800" textStyle="xs" fontWeight="600">
            © { new Date().getFullYear() } شرکت صبانفت — همه حقوق محفوظ است.
          </Text>
        </Box>
        <Flex direction="column" align={{ base: 'flex-start', lg: 'flex-end' }} gap={ 3 }>
          { !config.UI.indexingAlert.intTxs.isHidden && <IntTxsIndexingStatus/> }
          <NetworkAddToWallet/>
          <Text color="text.secondary" textStyle="xs">داده‌ها مستقیماً از زنجیره صبا دریافت می‌شوند.</Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default React.memo(Footer);
